import { useEffect, useState } from "react";
import { ChevronDown, Minus, Plus } from "lucide-react";
import { availabilityOf, formatPrice } from "@/lib/format";

export const Price = ({ product, className = "", testId, from = false }) => {
  const value = typeof product?.price === "number" ? product.price : null;
  return (
    <span data-testid={testId} className={className}>
      {from && value !== null && <span className="mr-1.5 text-xs font-normal text-taupe">desde</span>}
      <span className="font-semibold text-ink">{formatPrice(value)}</span>
      {value !== null && product?.priceIsExample && <span className="ml-1.5 text-xs font-normal text-taupe">(valor de exemplo)</span>}
    </span>
  );
};

export const AvailabilityBadge = ({ product, testId }) => {
  const a = availabilityOf(product);
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-[7px] rounded-full text-xs font-medium ${a.tone}`}>
      <span aria-hidden="true" className="h-1.5 w-1.5 shrink-0 rounded-full bg-current" />
      {a.label}
    </span>
  );
};

export const QuantityStepper = ({ value, onChange, max = 10, testPrefix = "quantity", small = false }) => {
  const btn = `grid place-items-center rounded-full text-ink transition-colors hover:bg-linen disabled:opacity-30 ${small ? "h-9 w-9" : "h-11 w-11"}`;
  return (
    <div className="inline-flex items-center rounded-full border border-ink/15 bg-ivory p-1" role="group" aria-label="Quantidade">
      <button type="button" data-testid={`${testPrefix}-decrease-button`} className={btn} onClick={() => onChange(value - 1)} disabled={value <= 1} aria-label="Diminuir quantidade">
        <Minus className="h-4 w-4" />
      </button>
      <span data-testid={`${testPrefix}-value`} className="w-8 text-center text-sm font-semibold tabular-nums" aria-live="polite">
        {value}
      </span>
      <button type="button" data-testid={`${testPrefix}-increase-button`} className={btn} onClick={() => onChange(value + 1)} disabled={value >= max} aria-label="Aumentar quantidade">
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
};

// Listas longas: mostra uma parte e deixa "Ver mais" (volta ao início quando muda o filtro, `resetKey`).
export const useShowMore = (list, step, resetKey = "") => {
  const [count, setCount] = useState(step);
  useEffect(() => setCount(step), [resetKey, step]);
  return { shown: list.slice(0, count), remaining: Math.max(0, list.length - count), more: () => setCount((c) => c + step), step };
};

export const ShowMore = ({ remaining, step, onClick, testId = "show-more" }) => remaining > 0 && (
  <div className="mt-8 flex justify-center sm:mt-10">
    <button type="button" onClick={onClick} data-testid={testId} className="bb-btn-ghost min-h-[48px] px-6 text-sm"><ChevronDown className="h-4 w-4" aria-hidden="true" /> Ver mais {Math.min(step, remaining)}</button>
  </div>
);
